var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.jobList.length > 0)?_c('div',{staticClass:"g-wrap job-wrap"},[_c('div',{staticClass:"column-wrap"},_vm._l((_vm.jobList),function(item){return _c('job-card',{key:item.id,attrs:{"data":item}})}),1)]):_c('div',{staticClass:"g-nodata"})}
var staticRenderFns = []

export { render, staticRenderFns }